const Form008SC = {
    stepName: {
        importantNotes: "重要提示",
        application: "申请讯息",
        confirmation: "确认",
    },
    importantNotes: {
        title: "重要事项",
        note: "获学校推荐的公益少年团团员需填妥电子申请表，并提交正面半身近照及团员记录册予所属学校的公益少年团负责教师，以便安排上载相关文件。",
    },
    notes: {
        importantNotes:
            "获学校推荐的公益少年团团员需填妥电子申请表，并提交正面半身近照及团员记录册予所属学校的公益少年团负责教师，以便安排上载相关文件。",
        noteOne: "本人已于",
        year: "年",
        month: "月",
        day: "日",
        noteTwo: "完成团员奖励计划的",
        level: "级（",
        chapter: "章）级别。",
        statementOne: "收集申请者个人资料声明",
        blackCircle: "●",
        statementTwo:
            "学生所提交的个人资料及相关文件（如个人资料表及证件影印本等），将用于处理参加交流团之用。参加者如未能提供所需资料，有关申请将不获受理。",
        statementThree:
            "教育局会按需要，将个人资料送交获授权处理的航运机构、酒店、旅行社、保险公司或相关单位，以便安排学习、交流、参访、住宿、交通及紧急医疗等事宜。",
        statementFour:
            "所有个人资料及相关文件（包括个人资料表及证件影印本等）将于交流团完结后销毁。",
        statementFive:
            "获提名参加者有权根据《个人资料（私隐）条例》（香港特别行政区法例第 <b>486</b> 章）第 <b>18</b> 和 <b>22</b> 条，以及附表 <b>1</b> 第 <b>6</b> 项原则规定，查阅和更正所提供的个人资料。如对参加交流团所收集的个人资料有任何查询，包括查阅及更正数据，请联络香港湾仔皇后大道东 <b>213</b> 号胡忠大厦 <b>11</b> 楼 <b>1141</b> 室教育局公益少年团办事处（电话：<b>2892 6660</b>）。",
        // pography_a: "(a) 办理与聘用有关的事宜；",
        // pography_b: "(b) 处理发放薪金津贴，以及计算公积金的供款和赠款；",
        // pography_c: "(c) 进行核数工作；",
        // pography_d: "(d) 进行研究及统计资料，以便规划教育服务；",
        // pography_e: "(e) 处理有关教育专业人员发展的事宜；",
        // pography_f:
        //     "(f) 执行《教育条例》、《教育规例》及附属《补助/津贴学校公积金规则》(第279章)。",
        // pographyOne:
        //     "申请人必须在本表格上填写个人资料。申请人如不提供这些资料，申请的处理工作及结果或会受影响。",
        // pographyTwo:
        //     "本表格所搜集的个人资料，或会向其他获授权的政府决策局/部门/机构披露作上述用途。",
        // pographyThree:
        //     "根据《个人资料(私隐)条例》，第18和22条及附表1保障资料第6原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
        // pographyFour:
        //     "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向教育局提出。",
    },
    title: {
        headerOne:
            "{{schoolyear}}年公益少年团杰出团员{{country}}交流团提名表格（团员适用）",
        headerTwo: "家长╱监护人同意书",
        headerThree: "收集申请者个人资料声明",
        recommendation:
            "{{schoolyear}}年公益少年团杰出团员{{country}}交流团校长推荐书（团员适用）",
    },
    genderOption: {
        M: "男",
        F: "女",
    },
    joinOption: {
        yes: "有",
        no: "没有",
    },
    languageOption: {
        gd: "广东话",
        en: "英语",
        cn: "普通话",
        korean: "***",
        other: "其他",
    },
    newLanguageOption: {
        gd: "广东话",
        en: "英语",
        cn: "普通话",
        other: "其他",
    },
    languageLevelOption: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
    },
    levelOption: {
        1: "小学基本",
        2: "小学初",
        3: "小学中",
        4: "小学高",
        5: "中学基本",
        6: "中学初",
        7: "中学中",
        8: "中学高",
        9: "三等荣誉",
        10: "二等荣誉",
        11: "一等荣誉",
    },
    chapterOption: {
        1: "粉黄",
        2: "粉绿",
        3: "粉橙",
        4: "粉紫",
        5: "黄",
        6: "绿",
        7: "橙",
        8: "紫",
        9: "蓝星荣誉徽",
        10: "白星荣誉徽",
        11: "红星荣誉徽",
    },
    careForOption: {
        yes: "需要",
        no: "不需要",
    },
    label: {
        termsConditions: "本人已阅读、理解及同意上述条款及条件。",
        nameCn: "获提名团员中文姓名",
        nameEn: "获提名团员英文姓名",
        sex: "性別",
        dateBirth: "出生日期",
        hkId: "身份证号码",
        recentPhoto: "正面半身近照",
        award: "团员纪录册",
        stuTel: "学生联络电话",
        school: "就读学校",
        grade: "班级",
        schoolAddress: "学校地址",
        schoolTel: "学校电话",
        schoolFax: "学校传真",
        one: "本人已于___年___月___日",
        two: "完成团员奖励计划的___级（___章） 级别。",
        language: "能操语言",
        other: "其他（请注明）",
        interests: "兴趣/专长",
        experience: "简述参与公益少年团一项难忘的服务经验",
        isJoinActivity: "曾否参加境外交流活动",
        projectName: "活动名称",
        projectDate: "日期",
        isApply: "有否同时申请本学年暑假期间举行的其他境外交流团",
        projectApplyName: "活动名称",
        dateApply: "日期",
        applicantSign: "获提名团员签署",
        agreeOne: "本人同意敝子弟",
        applyName: "（获提名团员姓名）",
        agreeName: "子弟",
        join: "參加",
        joinOne: "年公益少年团杰出团员",
        joinTwo:
            "交流团，并承诺一旦获选，定当督促其出席出发前所有训练及交流结束后的小组报告汇报日，以及在旅途中遵从导师和领队的指示，并完成有关交流成果的小组报告。",
        group: "交流团",
        parentsName: "家长/监护人姓名",
        parentsTel: "家长联络电话",
        relation: "与获提名团员的关係",
        schoolName: "学校名称",
        nameOfApplicantCn: "获提名团员姓名（中文）",
        nameOfApplicantEn: "获提名团员姓名（英文）",
        conduct: "获提名团员的品行",
        performance: "获提名团员在公益少年团的表现（例如做事的积极性、态度等）",
        cnLevel: "普通话",
        enLevel: "英语",
        koreanLevel: "韩语",
        careFor: "获提名团员于参与面试或境外交流时是否需要特别照顾",
        careDesc: "请注明",
        otherComments: "其他评语",
        nameOfPrincipal: "校长姓名",
        principalTel: "学校电话",
        approverEmailAddress: "家长电邮",
        emailAddress: "电邮地址",
        ability: "获提名团员的语言能力（1 分最低至 5 分最高）",
        sentence:
            "学校在推荐团员参加公益少年团杰出团员交流团时，请考虑该团员以往曾否参加境外交流活动，并优先推荐未曾参加过境外交流活动的团员。",
    },
    errorMsg: {
        relation: "关系",
    },
    signature: {
        approver:
            "这张表格已被發送到批核方，待批核方發送電郵至申請者電郵，申請者再依從電郵指示登入以完成整個申請。",
    },
};
export default Form008SC;
